const currentDate = new Date();
currentDate.setHours(0, 0, 0, 0);

const buildDepartmentNameMap = (departmentList: any[]): Record<string, string[]> =>
    departmentList.reduce((a: Record<string, string[]>, dept: any) => {
        (dept.codes || []).forEach((code: string) => {
            a[code] = [...(a[code] || []), dept.id];
        });
        return a;
    }, {});

export const getActiveLinks: any = (userCardList: any, departmentTypes: any, departmentList?: any[]) => {

    const getDepartmentName = buildDepartmentNameMap(departmentList || []);

    let activeLinks = [] as string[];

    activeLinks = userCardList?.apps ? userCardList.apps.filter((item: any) => {
        if (!item.startDate) {
            return false;
        }

        const linkStartDate = new Date(item.startDate);
        linkStartDate.setHours(0, 0, 0, 0);

        const hasEndDate = !!item.endDate;
        let isActive = false;

        if (hasEndDate) {
            const linkEndDate = new Date(item.endDate);
            linkEndDate.setHours(0, 0, 0, 0);

            isActive = currentDate >= linkStartDate && currentDate <= linkEndDate;
        } else {
            isActive = currentDate >= linkStartDate;
        }

        if (item.target?.department) {
            // Hide department-targeted links until departments load so they never flash for the wrong department
            if (!departmentList) {
                return false;
            }

            const allowedDepartments = departmentTypes
                ?.flatMap((code: string) => getDepartmentName[code] || []);

            if (allowedDepartments && allowedDepartments.length > 0) {
                const isMatchingDept = item.target?.department.some(
                    (dept: string) => allowedDepartments.includes(dept)
                );

                return isActive && isMatchingDept;
            }
            return isActive;
        }

        return isActive;
    }) : []

    return activeLinks;
};